<template>
    <div>
     <b-modal :id="ModalId" 
     @shown="prepararDrag"
     :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalSignPatientGuardian" @close="this.emitEventCancel" @ok="this.emitEventOK" @cancel="this.emitEventCancel" style="padding:0.5px 20px" :cancel-title="$t('Shared.BtnCancel')"> 
        <!--<div v-for="(s, sigindex) in this.Signatures" :key="'signature_'+sigindex">-->
            <!--<div class="card bg-light">
                <div class="card-body">  
                  
                 
                </div>
            </div> --> 
            <b-row v-if="ShowGuardianDrop">
              <b-col lg="12" md="12" sm="12">         
                <MdSelect
                    v-bind:Label="$tc('Contact.Contact')"
                    v-bind:Options="GuardianList"
                    v-bind:FieldDescription="'contactName'"
                    v-bind:FieldCode="'recNo'"                      
                    v-bind:Model="GuardianModel"                                 
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownGuardian"
                />
            </b-col>
            </b-row>
            <MdSignature              
              v-bind:Data64="this.Image" 
              v-bind:Id="'Patient_Contact_Signature'+this.ModalId" 
              v-bind:Title="this.Option" 
              v-bind:VisibleLoadImage="false">

            </MdSignature>        
        <!--</div>  -->      
     </b-modal>        
    </div>
</template>
 
 <script>
 //import Utils from '@/common/utils'
 import ShowMessage from '@/components/messages/ShowMessage.js'
 import ContactService from '@/services/contact.service'
 import { EventBus } from '@/event-bus.js';

 
 export default {
   name: 'wyModalSignPatientGuardian',
   mixins: [ShowMessage],  
   props: {
     ModalId: String,
     VisibleGuardian:Boolean,
     TitleWindow: String,  
     Option: String,
     Image:String,  
     ItemChecked:Object, 
     ShowGuardianDrop:Boolean,
     PatientCode:String
   },
   
   data(){
     return {  
      GuardianList:[], 
      GuardianModel:{contactName:"",recNo:""},  
      Base64:"",   
     }
   },
 
   methods:{   
    prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
    if (!outer) {
      console.warn("No se encontró el contenedor del modal");
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      console.warn("No se encontró header o dialog");
      return;
    }

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},
     emitEventOK(bvModalEvent){
      let data = {};
      if(this.ShowGuardianDrop){
        data.base64 = this.Base64;
        data.guardianCode = this.GuardianModel.recNo;
      }else{
        data.base64 = this.Base64;
        data.guardianCode = "";
      }
     // this.$emit('ModalTPSignPatientGuardianWizardOK',data);
      if(this.ShowGuardianDrop){
       if(this.GuardianModel.recNo !== null && this.GuardianModel.recNo !== "" && this.Base64 !== ""){
        this.$emit('ModalTPSignPatientGuardianWizardOK',data);
      }else{
          bvModalEvent.preventDefault(); 
        this.showMessage(this.$tc('Msg.Error'), this.$t('treatmentplan.NoGuardianSignature'), "error");
      }
    }
    else{
        if(this.Base64 !== null && this.Base64 !== ""){
          this.$emit('ModalTPSignPatientGuardianWizardOK',data);
        }else{
           bvModalEvent.preventDefault(); 
          this.showMessage(this.$tc('Msg.Error'), this.$t('treatmentplan.NoPatientSignature'), "error");
        }
      }
     },
       
     emitEventCancel(){
        let data = {
            item:this.ItemChecked,
            option:this.Option
        }
      this.$emit('ModalTPSignPatientGuardian',data);
    }, 
    ChangeDropDownGuardian(value){      
      this.GuardianModel = value ? value :{};
    },

    async getContactByPatient() {
            this.$emit('load', true);
            await ContactService.getByCode(this.PatientCode)
                .then((response) => {
                    if (response.status == '200' && response.data) {
                        this.GuardianList = response.data;      
                        
                        if(this.GuardianList.length === 1){
                          this.GuardianModel.contactName = this.GuardianList[0].contactName;
                          this.GuardianModel.recNo = this.GuardianList[0].recNo;
                        }
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), "error");
                    }
                    else if (error.response.status === 400) {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    } else if (error.response.status === 500) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    }
                });
        },
 
   
   },

   created(){
    EventBus.$on("onMouseStop", function (image) { 
      this.Base64 = image ? image.split(",")[1] : "";      
     }.bind(this));
   },

  async mounted(){
    if(this.ShowGuardianDrop){
      await this.getContactByPatient();
    }
   },

   beforeDestroy () {     
    EventBus.$off('onMouseStop');    
  },
 };
 </script>

 <style>
.custom-modal-header {
  cursor: move;
  user-select: none;
}

.modal-header {
  cursor: move;
  user-select: none;
}

.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none; /* evita seleccionar texto al arrastrar */
}
</style>